/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PrivateOffer_conversation = {|
  +item: ?{|
    +displayInfo: ?{|
      +pricing: ?{|
        +quantityDisplay: ?string;
      |};
    |};
  |};
  +hasActiveHoldForBuyer: ?boolean;
  +relevantItemHold: ?{|
    +expirationDate: ?string;
  |};
  +transaction: ?{|
    +isPrivateOffer: ?boolean;
    +mostRecentOffer: ?{|
      +expirationDate: ?string;
      +amountPerItem: ?{|
        +convertedAmountList: ?$ReadOnlyArray<?{|
          +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
          +amount: ?number;
        |}>;
      |};
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PrivateOffer_conversation",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "page",
              "value": "pdp",
              "type": "PageDisplayEnum"
            }
          ],
          "concreteType": "ItemDisplayInfo",
          "name": "displayInfo",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "PriceInfoDisplay",
              "name": "pricing",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "quantityDisplay",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "displayInfo{\"page\":\"pdp\"}"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "hasActiveHoldForBuyer",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Hold",
      "name": "relevantItemHold",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "expirationDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Transaction",
      "name": "transaction",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "isPrivateOffer",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Offer",
          "name": "mostRecentOffer",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "expirationDate",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "name": "amountPerItem",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "ConvertedAmountList",
                  "name": "convertedAmountList",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "currency",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "amount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Conversation"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/__generated__/PrivateOffer_conversation.graphql.js